import React from 'react';

import Typography from '@material-ui/core/Typography';

/*
*/
export default function Policies(props) {
    if (props.element.length <= 0) {
        return 'No policies defined';
    }

    function createMarkup(text) {
        return { __html: text };
    }

    return (
        <React.Fragment>
            {
                props.element.map((policy, index) => {
                    let policyText = null;
                    if(policy.Policy) policyText = policy.Policy;
                    if(policy.PolicyText) policyText = policy.PolicyText;
                    return (
                        <React.Fragment key={index}>
                            <h3>{policy.PolicyName}</h3>
                            <Typography variant="body1" gutterBottom>
                                <span dangerouslySetInnerHTML={createMarkup(policyText)}></span>
                            </Typography>
                        </React.Fragment>
                    );
                })
            }
        </React.Fragment>
    )
}